// @flow

type Callback = () => void;

type Subscriber = {
    [seconds: number]: Array<Callback>,
};

type Timer = {|
    subscribe: (seconds: number, cb: Callback) => () => void,
|};

const subscribers: Subscriber = {};
let total: number = 0;

export const loop = () => {
    total++;

    for (const key in subscribers) {
        if (!subscribers.hasOwnProperty(key)) {
            continue;
        }

        const seconds = Number(key);

        if (total % seconds === 0) {
            subscribers[seconds].forEach(cb => cb());
        }
    }
};

setInterval(loop, 1000);

export const timer: Timer = {
    subscribe: (seconds, cb) => {
        if (!subscribers.hasOwnProperty(seconds)) {
            subscribers[seconds] = [];
        }

        subscribers[seconds].push(cb);

        return () => {
            const list = subscribers[seconds];
            const index = list.indexOf(cb);
            if (index !== -1) {
                list.splice(index, 1);
                if (list.length === 0) {
                    delete subscribers[seconds];
                }
            }
        };
    }
};
